import { Space } from 'antd';
import { useContext, useMemo } from 'react';

import { CLIENT_STATUSES, VISITS_FILTER } from '@app/constants';
import { ClientFiltersContext } from '@app/providers';
import { generateKey } from '@app/utils';

import { ClientFilterTag } from '@pages/Clients/ClientsList/components/Filters/ClientFilterTag';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const ClientsRecordStatusesLabel = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const { filters, serverFilters, setFilters, setServerFilters } =
    useContext(ClientFiltersContext);

  const memoizedStatuses = useMemo(
    () => serverFilters.VisitsFilter?.[filterGroupIndex]?.Values?.[0]?.Statuses,
    [serverFilters, filterGroupIndex]
  );

  return (
    <Space
      className={`clients-record-statuses-label${filterGroupIndex}`}
      direction="vertical"
    >
      <span>Статус записей</span>
      {memoizedStatuses !== null && memoizedStatuses?.length > 0 && (
        <Space direction="vertical">
          {memoizedStatuses.map((statusId, index) => (
            <ClientFilterTag
              key={generateKey('ClientRecordsStatusesLabel', statusId)}
              componentKey={generateKey('ClientRecordsStatusesLabel', statusId)}
              filters={filters}
              serverFilters={serverFilters}
              filtersArea={VISITS_FILTER}
              filterGroupIndex={filterGroupIndex}
              setFilters={setFilters}
              setServerFilters={setServerFilters}
              valueKey={
                'Statuses' as keyof NClientsList.VisitsFilterUnitValue['Statuses']
              }
              specificFilterArrayIndex={index + 1}
            >
              {CLIENT_STATUSES.find(({ id }: { id: string }) => id === statusId)
                ?.label || 'Без названия'}
            </ClientFilterTag>
          ))}
        </Space>
      )}
    </Space>
  );
};
